import {
  AfterContentInit,
  Component,
  ContentChild,
  DoCheck,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ILogger, LoggerService } from '@wz-services';
import {
  getAllControlsFiltered,
  getControlCompletionPercentage,
  WithControls,
} from '@wz-utilities/form.utilities';
import { FormGroupBaseComponent } from '../form-group-base.component';

@Component({
  selector: 'wz-form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group.component.scss'],
  standalone: false,
})
export class FormGroupComponent implements OnInit, AfterContentInit, DoCheck {
  @Input() formGroupControl!: WithControls;
  @Input() includedControls!: string[];
  @Input() excludedControls!: string[];
  @Input() expandable = false;
  @Input() expanded = true;
  @Input() disabled = false;
  @Input() forceValidBar = false;

  @ContentChild(FormGroupBaseComponent, { static: true })
  group!: FormGroupBaseComponent<any>;

  @ViewChild('contentEl', { static: false }) contentEl!: ElementRef;

  private logger: ILogger;

  private oldContentElemCount = 0;

  constructor(loggerService: LoggerService) {
    this.logger = loggerService.getLogger('FormGroupComponent');
  }

  ngOnInit(): void {}

  ngAfterContentInit() {
    if (this.group) {
      this.formGroupControl = this.group.formGroup;
    }
  }

  get percentageCompletion() {
    if (this.disabled) {
      return 100;
    }
    try {
      return getControlCompletionPercentage(
        this.formGroupControl,
        this.includedControls || null,
        this.excludedControls || null,
      );
    } catch (err) {
      this.logger.error(err);
      return 0;
    }
  }

  get showValidBar() {
    if (this.disabled && !this.forceValidBar) {
      return false;
    }
    const controls = getAllControlsFiltered(
      this.formGroupControl,
      this.includedControls,
      this.excludedControls,
    );
    return this.forceValidBar || (controls && controls.every((c) => c.valid));
  }

  get showErrorBar() {
    if (this.disabled) {
      return false;
    }

    const controls = getAllControlsFiltered(
      this.formGroupControl,
      this.includedControls,
      this.excludedControls,
    );
    return (
      controls &&
      controls.findIndex((c) => c.dirty) !== -1 &&
      controls.findIndex((c) => c.invalid) !== -1
    );
  }

  get showPristineBar() {
    if (this.disabled) {
      return true;
    }

    const controls = getAllControlsFiltered(
      this.formGroupControl,
      this.includedControls,
      this.excludedControls,
    );
    return controls && controls.every((c) => c.pristine);
  }

  ngDoCheck() {
    if (!this.disabled || !this.contentEl || !this.contentEl.nativeElement) {
      return;
    }

    const element = this.contentEl.nativeElement as Element;
    const elems = element.querySelectorAll('*');
    if (elems.length !== this.oldContentElemCount) {
      this.oldContentElemCount = elems.length;
      let i = 0,
        length = elems.length;
      for (; i < length; i++) {
        const el = elems[i];
        el.setAttribute('tabIndex', '-1');
      }
    }
  }
}
